import { gql } from '@src/lib/gql'

/** No input arg — BE mutation has no inputFields (empty GraphQL inputs are invalid). */
export const REFRESH_ADVISOR_CONNECT_STATUS = gql`
  mutation RefreshAdvisorConnectStatus {
    refreshAdvisorConnectStatus {
      advisorProfile {
        id
        advisorProfileId
        stripeConnectAccountId
        stripeConnectStatusKey
        hourlyRate
        isSessionEnabled
        timezone
        canAcceptSessions
      }
    }
  }
`
